import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button, Container, Grid, Header, Segment } from 'semantic-ui-react'

import { getProjectionTimeseries } from '../../services/projections';
import LineChart from '../lineChart';
import ResultsAccordion from '../resultsAccordion';

import { AllScenarioWrapper } from './allScenarioWrapper';

import { idToDescription } from '../../utils';

// Fixtures
import CARDS from '../../data/cards';
import { CONFIG } from '../../data/config';
import { IAppState } from '../../store/reducers';
import { getPassengerDistanceTraveledSeries } from '../../store/selectors/passengerDistanceTraveled';
// import { getProjectedModalSplitByOwnerAndTypeSeries } from '../../store/selectors/modalSplit';

import ScenarioChart from './scenarioChart';

// Needed to work with typescript
// https://github.com/s-panferov/awesome-typescript-loader/issues/146#issuecomment-365594745
/* tslint:disable:no-var-requires */
const styles = require('./styles.module.scss');

// The keys must match the entries for "key" in ../../data/cards.js
/* tslint:disable:object-literal-sort-keys */
const CHART_METADATA: any = {
  passengerDistanceTraveled: {
    title: "Annual Passenger Kilometers Traveled per Capita",
    yAxisLabel: "kilometers"
  },
  vehicleDistanceTraveled: {
    title: "Annual Total Vehicle Kilometers",
    yAxisLabel: "billion kilometers"
  },
  co2Emissions: {
    title: "Carbon Dioxide Emissions from Passenger Mobility",
    yAxisLabel: "tons"
  },
  pm25Emissions: {
    title: "Vehicular Particulate Matter (PM-2.5) Emissions",
    yAxisLabel: "PPM (parts per million)"
  },
  modalSplit: {
    title: "Modal Split",
    yAxisLabel: "percentage"
  }
};

interface ITitleProps {
  index: number;
}

interface IState {
  selectedIndex: number;
}



class ResultsPane extends Component<any, IState> {
  constructor(props: any) {
    super(props);
    this.state = {
      selectedIndex: 0,
    }
  }

  // When a title is clicked, swap!
  public handleClick = (e: React.MouseEvent<HTMLElement>, props: ITitleProps) => {
    const { index } = props;
    this.setState({ selectedIndex: index })
  }

  public render() {
    const { selectedIndex } = this.state;
    const selectedChartKey = CARDS[selectedIndex].key;
    const metadata = CHART_METADATA[selectedChartKey];

    // The data to render
    // Presently, the timeseries is reading from FIXTURES
    let chartData = getProjectionTimeseries(selectedChartKey);
    // override if we have real data...
    const dataSeries = this.props[selectedChartKey];
    if (dataSeries) {
      chartData = dataSeries.map((series: any) => ({
        ...series,
        id: idToDescription(series.id)
      })).reverse()
    }

    let chart;
    let height = '500px';

    if (selectedChartKey === 'modalSplit') {
      chart = (
        <>
          <ScenarioChart
            scenarioKey='bau'
            title="Business as Usual"
            hasLegend={true}
          />
          <ScenarioChart
            scenarioKey='primary'
            title="Scenario 1"
            hasLegend={false}
          />
          <ScenarioChart
            scenarioKey='secondary'
            title="Scenario 2"
            hasLegend={false}
          />
        </>
      );
      height = '700px';
    } else if (selectedChartKey === 'passengerDistanceTraveled')  {
      chart = <LineChart
        data={chartData}
        title={metadata.title}
        containerHeight={'350px'}
        yAxisLabel={metadata.yAxisLabel}
      />;
    } else { // the other 3 charts should have their own thing...
      chart = (
        <AllScenarioWrapper dataName={selectedChartKey}>
          {(props: any) => {
            return (
            <LineChart
              data={props.chartData}
              title={metadata.title}
              containerHeight={'350px'}
              yAxisLabel={metadata.yAxisLabel}
            />);
            }
          }
        </AllScenarioWrapper>
      )
    }

    return (
      <Container>
        <Segment raised={true} style={{ minHeight: height }}>
          <Header as="h3">Results</Header>
          <p>Projected outcomes based on user inputs.</p>
          <Container>
            <Grid columns={3}>
              <Grid.Row>
                <Grid.Column width="9">
                  <Container textAlign="center">{chart}</Container>
                </Grid.Column>
                <Grid.Column width="7">
                  <ResultsAccordion
                    activeIndex={selectedIndex}
                    cards={CARDS}
                    handleResultClick={this.handleClick}
                  />
                  <a
                    className={styles.buttonLink}
                    href={CONFIG.methodologyURL}
                    target="_blank"
                  >
                    <Button fluid={true}>See Assumptions</Button>
                  </a>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Container>
        </Segment>
      </Container>
    );
  }
}

const mapStateToProps = (state: IAppState, props: any) => ({
  // todo... make this return them for each scenario!!
  passengerDistanceTraveled: getPassengerDistanceTraveledSeries(state),
})

export default connect(mapStateToProps, null)(ResultsPane);



// WEBPACK FOOTER //
// ./src/components/resultsPane/index.tsx